import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { goodsViewAction } from "../../../redux/actions/purchase-action";
import CreateEditViewGrn from "../../../components/purchase-section/goods-receipt/create-edit-view-grn";

const ViewGoodsReceipt = () => {
  const { id } = useParams();

  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(goodsViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  return (
    <InnerLayout backBtn={true} title="Goods Receipt View">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewGrn
          // <GoodsRecComp
          payto={orderDetail?.orderData?.gort_pay_to_address}
          shipto={orderDetail?.orderData?.gort_ship_to_address}
          pageType="grn"
          page="view"
          disabled={true}
          data={orderDetail}
          orderDetail={orderDetail?.itemData}
          vendorDetails={[orderDetail?.orderData]}
        />
      )}
    </InnerLayout>
  );
};

export default ViewGoodsReceipt;
